import { NotificationManager } from 'react-notifications';

import 'react-notifications/lib/notifications.css';
import './styles.css';

const Notification = ({ type, message, title = '', timeout = 3000 }) => {
  switch (type) {
    case Notification.types.INFO:
      NotificationManager.info(message, title, timeout);
      break;
    case Notification.types.SUCCESS:
      NotificationManager.success(message, 'Sucesso', timeout);
      break;
    case Notification.types.WARNING:
      NotificationManager.warning(message, title, timeout);
      break;
    case Notification.types.ERROR:
      NotificationManager.error(message, title || 'Erro', 5000);
      break;

    default:
      NotificationManager.info(message);
  }
};

Notification.types = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
};

export default Notification;
